import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';
import LocalStorageHelper from '../helpers/local_storage';

export function onSubmit(fields) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.SUBMIT_SETTING_REQUEST,
			payload: {
				loadingSubmit: true
			}
		});

		const body = {
			user: {
				...fields
			}
		};

		const response = await API.user.updatePassword(body);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.SUBMIT_SETTING_ERROR,
				payload: {
					meta: response.meta,
					loadingSubmit: false
				}
			});
			return;
		}

		const { user: userData } = response.data;
		const user = LocalStorageHelper.getUser();
		const newUser = {
			...user,
			name: userData.name
		};

		// Set new user in local storage
		LocalStorageHelper.setUser(newUser);

		dispatch({
			type: ActionTypes.SUBMIT_SETTING_SUCCESS,
			payload: {
				meta: response.meta,
				loadingSubmit: false
			}
		});
	};
}

export function resetMeta() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_SETTINGS_META
		});
	};
}

export function resetPage() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_SETTINGS_PAGE
		});
	};
}